(function(a){a.fn.toggleDisabled=function(){return this.each(function(){this.disabled=!this.disabled})}})(jQuery);
